import script from "./ProfileCardBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCardBox.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCardBox.vue?vue&type=style&index=0&id=56defd54&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56defd54"]])

export default __exports__